// Create audio context
const BUFFER_SIZE = 4800;
class Player {
    constructor() {
        this.playbackNode = null;
        this.audioContext = null;
    }

    async init(sampleRate) {
        this.audioContext = new AudioContext({ sampleRate });
        await this.audioContext.audioWorklet.addModule("//www.codeage.com/cdn/shop/t/391/assets/component--audio-playback-worklet.js?v=13053064311760306271765817147");

        this.playbackNode = new AudioWorkletNode(this.audioContext, "audio-playback-worklet");
        this.playbackNode.connect(this.audioContext.destination);
    }

    play(buffer) {
        if (this.playbackNode) {
            this.playbackNode.port.postMessage(buffer);
        }
    }

    async stop() {
        if (this.playbackNode) {
            this.playbackNode.port.postMessage(null);
        }

        await this.audioContext.suspend()
    }
}   

class Recorder {
    constructor(onDataAvailable) {
        this.FFT_SIZE = 2048;
        this.onDataAvailable = onDataAvailable;
        this.audioContext = null;
        this.mediaStream = null;
        this.mediaStreamSource = null;
        this.workletNode = null;
        this.spectrum = new Uint8Array(this.FFT_SIZE/2);
        this.volume = this.vol = 0;
        this.peak_volume = 0;
        this.analyser = null;
    }

    

    async start() {
        try {
            if (this.audioContext) {
                await this.audioContext.close();
            }

            const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

            this.audioContext = new (window.AudioContext || window.webkitAudioContext)({ sampleRate: 24000 });

            this.analyser = new AnalyserNode(this.audioContext, {                
                smoothingTimeConstant: 0.80
            });

            this.analyser.minDecibels = -80;


            await this.audioContext.audioWorklet.addModule("//www.codeage.com/cdn/shop/t/391/assets/component--audio-processor-worklet.js?v=101925462322621293241765817147");

            this.mediaStream = stream;
            this.mediaStreamSource = this.audioContext.createMediaStreamSource(this.mediaStream);

            this.workletNode = new AudioWorkletNode(this.audioContext, "audio-processor-worklet");
            this.workletNode.port.onmessage = event => {
                this.onDataAvailable(event.data.buffer);
            };

            this.mediaStreamSource.connect(this.analyser);
            this.mediaStreamSource.connect(this.workletNode);
            this.workletNode.connect(this.audioContext.destination);
        } catch (error) {
            this.stop();
        }
    }

    async stop() {
        if (this.mediaStream) {
            this.mediaStream.getTracks().forEach(track => track.stop());
            this.mediaStream = null;
        }

        if (this.audioContext) {
            await this.audioContext.close();
            this.audioContext = null;
        }

        this.mediaStreamSource = null;
        this.workletNode = null;
    }

    getAnalyser(){
        return this.analyser;
    }

    getRMS(spectrum) {

          var rms = 0;
          for (var i = 0; i < spectrum.length; i++) {
            rms += spectrum[i] * spectrum[i];
          }
          rms /= spectrum.length;
          rms = Math.sqrt(rms);
          return rms;
    }

    map(value, min1, max1, min2, max2) {
        var returnvalue = ((value-min1) / (max1 - min1) * (max2-min2)) + min2;
        return returnvalue;
    };

    mapSound = function(_me, _total, _min, _max){
        if (this.spectrum.length > 0) {
        // map to defaults if no values given
        var min = _min || 0;
        var max = _max || 100;
        //actual new freq
        var new_freq = Math.floor(_me * this.spectrum.length /_total);
        // map the volumes to a useful number
        return this.map(this.spectrum[new_freq], 0, this.peak_volume, min, max);
        } else {
            return 0;
        }
        
    }
}




class CodeageVoice extends HTMLElement{
    constructor(){
        super();
        this.audioPlayer;
        this.audioRecorder;
        this.buffer = new Uint8Array();
        this.ws = null;
        this.isAudioOn = false;
        this.selectors = {
            toggleAudioBtn: '#toggle-codeage-voice',
            waveformCanvas: '#audio-waveform-visualizer'
        }
        this.drawVisual = null;

        //remember the last item id for tracking messages in OPENAI
        this._lastItemId = null;

        this.sessionID = '';
        this.sessionIDCookieName = "codeage-api-sessionID";

        this.metadata = {
            product_title: this.dataset.productTitle || "",
            locale: window.theme.locale || "en",
        }

        this.init();
    }

    async init(){
        this.sessionID = this.getSessionID();
        this.setupEventListeners()        
    }

    getSessionID() {
        return Cookies.get(this.sessionIDCookieName);
    }

    setSessionID(sessionID){

        Cookies.set(this.sessionIDCookieName, sessionID, 1)
        this.sessionID = sessionID;
    }

    setupEventListeners(){
        this.querySelector(this.selectors.toggleAudioBtn).addEventListener('click', this.handleToggleAudioBtn.bind(this));
    }

    async handleToggleAudioBtn(){
        let toggleButton = this.querySelector(this.selectors.toggleAudioBtn);
        if (!this.isAudioOn) {
            await this.initWebsocketConnection();
            this.classList.add('is-playing');
            this.isAudioOn = true;

            this.visualizeInput();
        } else {
            await this.stopAudio();
            this.classList.remove('is-playing');
            this.isAudioOn = false;

            //cancel animation frame
            cancelAnimationFrame(this.drawVisual);
        }
    }

    async initWebsocketConnection(){

        //get session cookie from server first
        console.log('getting session cookie');
        await this.getSessionCookie()

        this.sessionID = this.getSessionID();
        const url = window.theme.websocketUrl + "/websockets/codeageVoice?product_title=" + this.metadata.product_title + "&locale=" + this.metadata.locale;

        this.ws = new WebSocket(url);

        //handle incoming message
        this.ws.onmessage = this.handleWebsocketMessage.bind(this);
        
        this.initPlayer();
        await this.initRecorder();
        
    }

    async getSessionCookie(){
        let url = window.theme.apiUrl + "/session/setCookie"
        try {
            const response = await fetch(url, {
                credentials: 'include' // Ensures cookies are sent
            });
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            console.log(response);
        } catch (error) {
            console.error(error.message);
        }
    }

    async stopAudio(){
        this.ws.send(JSON.stringify({type: 'client.close' }));
        this.ws.close();
        await this.audioPlayer.stop();
        await this.audioRecorder.stop();
    }

    handleWebsocketMessage(event){
        const data = JSON.parse(event.data);

        //user input transcription
        if(data?.type === 'conversation.item.input_audio_transcription.completed'){
            this.handleTranscription({
                role: CODEAGEAICONST.messageRoles.HUMAN,
                content: data.transcript
            });
            return;
        }

        // model transciprtion
        if(data?.type === 'response.audio_transcript.done'){
            this.handleTranscription({
                role: CODEAGEAICONST.messageRoles.AI,
                content: data.transcript
            });
            return;
        }

        //save session
        if(data?.type === 'response.session.new'){
            console.log('sessionId:',  data.value)
            this.setSessionID(data.value);
            return;
        }

        if (data?.type !== 'response.audio.delta') return;

        let currentItemId = data.item_id;

        if(this._lastItemId != currentItemId){
            //if item id changed, stop playback by sending null data to audio worklet processor to clear the buffer;
            this.audioPlayer.play(null);
        }else{

            const binary = atob(data.delta);
            const bytes = Uint8Array.from(binary, c => c.charCodeAt(0));
            const pcmData = new Int16Array(bytes.buffer);

            this.audioPlayer.play(pcmData);
        }

        this._lastItemId = currentItemId;
    }

    handleTranscription(data){

        let event = new CustomEvent(CODEAGEAICONST.events.CHAT_ADD, {
            detail: data
        });
        document.dispatchEvent(event);
    }


    initPlayer(){
        const SAMPLE_RATE = 24000;
        this.audioPlayer = new Player();
        this.audioPlayer.init(SAMPLE_RATE);
    }

    async initRecorder(){
        // handle microphone -> input websocket
        this.audioRecorder = new Recorder(this.handleAudioData.bind(this));
        await this.audioRecorder.start();
    }


    visualizeInput(){
        let canvas = this.querySelector(this.selectors.waveformCanvas);

        if(!canvas){
            console.warn('Visualization Error: Canvas not found');
            return;
        }

        //set canvas initial width
        this.handleCanvasResize();

        let canvasCtx = canvas.getContext('2d');
        let WIDTH = canvas.width;
        let HEIGHT = canvas.height;

        let analyser = this.audioRecorder.getAnalyser();

        if(!analyser){
            console.warn('Mic analyser not initialized');
            return;
        }

        analyser.fftSize = 256;
        const bufferLengthAlt = analyser.frequencyBinCount;

        // See comment above for Float32Array()
        const dataArrayAlt = new Uint8Array(bufferLengthAlt);

        canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);

        const yStartingPoint = HEIGHT / 2;
        const barRadius = 10

        let drawVisual = this.drawVisual;

        function draw() {
            let WIDTH = canvas.width;
            let HEIGHT = canvas.height;

            drawVisual = requestAnimationFrame(draw);

            analyser.getByteFrequencyData(dataArrayAlt);

            canvasCtx.fillStyle = "#527cff";
            canvasCtx.fillRect(0, 0, WIDTH, HEIGHT);
            canvasCtx.fill();

            const barWidth = (WIDTH / bufferLengthAlt) * 2.5;
            let x = 0;
            

            //console.log(dataArrayAlt);


            for (let i = 0; i < bufferLengthAlt; i++) {
                const barHeight = dataArrayAlt[i];
                const normalizedValue = barHeight * HEIGHT / 255;
                let normalizedBarHeightMid = normalizedValue / 2;

                if(normalizedBarHeightMid == 0){
                    normalizedBarHeightMid = 1;
                }
                
                canvasCtx.fillStyle = "#fff";
                canvasCtx.strokeStyle = "#fff";

                //upper rect
                canvasCtx.beginPath();
                canvasCtx.roundRect(x, yStartingPoint, barWidth, normalizedBarHeightMid, [0 ,0 ,barRadius, barRadius])
                canvasCtx.stroke();
                canvasCtx.fill();
                //lower rect
                canvasCtx.beginPath();
                canvasCtx.roundRect(x, yStartingPoint, barWidth, normalizedBarHeightMid * -1, [0 ,0 ,barRadius, barRadius])
                canvasCtx.stroke();
                canvasCtx.fill();

                x += barWidth + 3;
                
            }

        }
        draw();

        window.addEventListener('resize', this.handleCanvasResize.bind(this));
    }

    handleCanvasResize(){
        let totalWidth = this.offsetWidth;
        let buttonWidth = this.querySelector(this.selectors.toggleAudioBtn).getBoundingClientRect().width;
        console.log('total Width: '. totalWidth);
        console.log('button Width: '. buttonWidth);

        let newCanvasWidth = totalWidth - buttonWidth;
        if(newCanvasWidth > 350) newCanvasWidth = 350;
        if(newCanvasWidth < 200) newCanvasWidth = 200;

        this.querySelector(this.selectors.waveformCanvas).width = newCanvasWidth

    }

    handleAudioData(data){
        const BUFFER_SIZE = 4800;
        const uint8Array = new Uint8Array(data);
        this.appendToBuffer(uint8Array);

        if (this.buffer.length >= BUFFER_SIZE) {
            const toSend = new Uint8Array(this.buffer.slice(0, BUFFER_SIZE));
            this.buffer = new Uint8Array(this.buffer.slice(BUFFER_SIZE));

            const regularArray = String.fromCharCode(...toSend);
            const base64 = btoa(regularArray);

            if(this.ws.readyState == WebSocket.OPEN){
                this.ws.send(JSON.stringify({type: 'input_audio_buffer.append', audio: base64}));
            }

        }
    }

    appendToBuffer(newData){
        const newBuffer = new Uint8Array(this.buffer.length + newData.length);
        newBuffer.set(this.buffer);
        newBuffer.set(newData, this.buffer.length);
        this.buffer = newBuffer;
    }

}

customElements.define('codeage-voice', CodeageVoice);


